import { connect } from "react-redux";
// API
import api from "api";
// Component
import CustomerList from "components/CustomerList";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  setCustomerList,
  changeSearchForm,
  changePage
} from "redux/modules/customerList";
import { openCustomerModal } from "redux/modules/customerModal";
import {
  showLinerProgress,
  hideLinerProgress
} from "redux/modules/linerProgress";
// Utils
import history from "utils/history";

const mapStateToProps = state => ({
  customerList: state.customerList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchCustomerList: (search, page) => {
    const params = { search, page };
    api
      .get("customer_list", params)
      .then(res => {
        dispatch(changePage(page));
        dispatch(setCustomerList(res));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  historyPush: path => () => {
    history.push(path, ownProps);
  },
  openCustomerModal: () => {
    // 新規のみ
    dispatch(showLinerProgress());
    api
      .get(`customer_modal/new`)
      .then(res => {
        dispatch(hideLinerProgress());
        dispatch(openCustomerModal(res.customer));
      })
      .catch(error => {
        dispatch(hideLinerProgress());
        dispatch(openErrorDialog(error));
      });
  },
  changeSearchForm: (key, value) => {
    dispatch(changeSearchForm(key, value));
  },
  changePage: page => {
    dispatch(changePage(page));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);



// WEBPACK FOOTER //
// ./src/containers/CustomerList/CustomerListContainer.js